// Avvisi che il login mostra dopo che una sessione è finita (inattività, token rifiutato dal server): si salvano in `localStorage` per
// sopravvivere al cambio di pagina. Un avviso vale UNA volta (si consuma appena letto) e non esiste per una sessione appena aperta.
export const AVVISO_INATTIVITA = "forceLogout";
export const AVVISO_SESSIONE_SCADUTA = "sessioneScaduta";

interface Archivio {
  getItem(chiave: string): unknown;
  removeItem(chiave: string): void;
}

/** Legge gli avvisi pendenti e li toglie entrambi. Se ce ne sono due si mostra solo l'inattività (la causa più specifica). */
export function consumaAvvisiSessione(archivio: Archivio): "inattivita" | "sessione_scaduta" | null {
  const inattivita = Boolean(archivio.getItem(AVVISO_INATTIVITA));
  const scaduta = Boolean(archivio.getItem(AVVISO_SESSIONE_SCADUTA));
  azzeraAvvisiSessione(archivio);
  return inattivita ? "inattivita" : scaduta ? "sessione_scaduta" : null;
}

/** Un accesso riuscito cancella ogni avviso: una sessione appena aperta non può essere scaduta. */
export function azzeraAvvisiSessione(archivio: Pick<Archivio, "removeItem">): void {
  for (const chiave of [AVVISO_INATTIVITA, AVVISO_SESSIONE_SCADUTA]) {
    try {
      archivio.removeItem(chiave);
    } catch {
      // archivio non disponibile (finestra privata): niente da pulire
    }
  }
}
